import type { ConsoleMe } from '@plato/shared';

export function NoAccessPage(props: { me: ConsoleMe; onSignOut: () => void }) {
  const { account } = props.me;
  return (
    <main className="sign-in" aria-labelledby="page-title">
      <h1 id="page-title">No access yet</h1>
      <p>
        You are signed in as <strong>{account.email ?? account.name ?? account.id}</strong>, but you
        are not a member of any vendor's console. Ask an admin of your team for an invite link.
      </p>
      <p className="muted">
        Your account id is <code>{account.id}</code>.
      </p>
      <button type="button" onClick={props.onSignOut}>
        Sign out
      </button>
    </main>
  );
}
